/* My Account → Order Status → Overview: the shipment route card (2026-10-19, Brett picked "B2 compact"
   on the canvas https://claude.ai/artifact/23DGmNkh54xxA8pBaQfV9r). It sits where the old "Tracking"
   line was, at the bottom of Overview — nothing else on the tab moves or hides.
   • Closed: headline ("Your order has shipped!" / "Arriving today" / "Delivered!" / …), arrival date,
     the route of stops so far (where it started → the last few cities → here now → destination), the
     tracking number with Copy and a link to the carrier's site.
   • "See every update" opens every scan, a chip per box, time in transit and each box's number.
   • The shipped / delivered moment animates once per order per state in this browser
     (localStorage idps_trk_seen); after that only the truck's soft pulse remains. No motion at all
     under prefers-reduced-motion.
   • Canceled labels never reach the page (the worker drops them). Factory-direct orders show
     "Production facility" for the shipper's town (the worker blanks that city before it gets here).
   Data: o.tracking = [{num, link, status}] from the worker (handleOmpOrders → trackStatusCached):
   status = {status, delivered, exception, out, label, date, eta, etaType, time, signer, shipDate,
   service, dest:{city,st}, home, scans:[{d:'YYYYMMDD', t:'HH:MM', city, st, cc, desc, k, fac}]}.
   window.MPTrack(h) → { html(o) }, h.ro() = Staff View. Plain ES5. Styles: .trk2* in my-profile.css. */
(function () {
  'use strict';
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var SEEN_KEY = 'idps_trk_seen', OLD_DAYS = 7, PLAY_SECS = 3.2;
  var ROUTES = [['full', 2], ['mid', 1], ['short', 0]];   // strip version → how many passed cities it shows

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function pd(s) { var m = /^(\d{4})(\d{2})(\d{2})$/.exec(String(s || '')); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; }
  function today0() { var d = new Date(); d.setHours(0, 0, 0, 0); return d; }
  function days(a, b) { return Math.round((b - a) / 86400000); }   // whole days from a to b
  function hm(t) { var m = /^(\d{2}):(\d{2})$/.exec(String(t || '')); if (!m) return ''; var h = +m[1]; return (h % 12 || 12) + ':' + m[2] + ' ' + (h >= 12 ? 'PM' : 'AM'); }
  function dLong(s) { var d = pd(s); return d ? DOW[d.getDay()] + ', ' + MON[d.getMonth()] + ' ' + d.getDate() : ''; }   // Thu, Oct 22
  function dRel(s) {   // Today · Yesterday · Mon · Oct 3
    var d = pd(s); if (!d) return '';
    var n = days(d, today0());
    if (n === 0) return 'Today';
    if (n === 1) return 'Yesterday';
    if (n > 1 && n < 7) return DOW[d.getDay()];
    return MON[d.getMonth()] + ' ' + d.getDate();
  }
  function when(s) { var r = dRel(s.d), t = hm(s.t); return r + (t ? (r === 'Today' || r === 'Yesterday' ? ', ' : ' · ') + t : ''); }
  function carrierOf(t) {
    var l = String(t && t.link || '');
    if (/ups\.com/i.test(l)) return 'UPS';
    if (/fedex\.com/i.test(l)) return 'FedEx';
    if (/usps\.com/i.test(l)) return 'USPS';
    return '';
  }
  function placeOf(s) {
    if (s.fac) return 'Production facility';
    var c = String(s.city || '').trim();
    if (!c) return '';
    return c + (s.st ? ', ' + s.st : (s.cc && s.cc !== 'US' ? ', ' + s.cc : ''));
  }

  // ── state ────────────────────────────────────────────────────────────────
  function boxState(t) {
    var s = t && t.status;
    if (!s) return 'none';
    if (s.delivered) return 'dl';
    if (s.exception) return 'x';
    if (s.out) return 'out';
    if (s.label) return 'label';
    return 'tr';
  }
  var BOX_TXT = { dl: 'Delivered', x: 'Delayed', out: 'Out for delivery', label: 'Label made', tr: 'In transit', none: 'No updates yet' };
  // The whole order: every box delivered → dl (old after a week); some → part; any delay → x; any out → out;
  // all label-only → label; else tr. No box has a status (USPS, freight, lookup unavailable) → none.
  function orderState(boxes) {
    var st = boxes.map(boxState), has = st.filter(function (k) { return k !== 'none'; });
    if (!has.length) return 'none';
    var dl = has.filter(function (k) { return k === 'dl'; }).length;
    if (dl === st.length) return 'dl';
    if (dl > 0) return 'part';
    if (has.indexOf('x') !== -1) return 'x';
    if (has.indexOf('out') !== -1) return 'out';
    if (has.every(function (k) { return k === 'label'; })) return 'label';
    return 'tr';
  }
  function leadIndex(boxes, state) {
    var want = { x: 'x', out: 'out', part: null }[state], i;
    for (i = 0; i < boxes.length; i++) {
      var k = boxState(boxes[i]);
      if (state === 'part' ? (k !== 'dl' && k !== 'none') : (want ? k === want : k !== 'none')) return i;
    }
    for (i = 0; i < boxes.length; i++) { if (boxes[i].status) return i; }
    return 0;
  }
  function deliveredOn(boxes) {   // the latest delivery date among delivered boxes (YYYYMMDD)
    var best = '';
    boxes.forEach(function (b) { var s = b.status; if (s && s.delivered && s.date > best) best = s.date; });
    return best;
  }
  // A real name only: FedEx puts "Signature not required" (and UPS sometimes "N/A") in the signer field.
  function signerOf(st) {
    var s = String(st && st.signer || '').trim();
    return s && !/not\s+required|no\s+signature|signature\s+release|^n\/?a$|^none$|^unknown$/i.test(s) ? s : '';
  }
  // Days from the carrier's pickup to delivery (Mon → Thu = 3), at least 1. 0 = not known.
  function transitDays(st, delivered) {
    var a = pd(shipDateOf(st)), b = pd(delivered);
    return a && b ? Math.max(1, days(a, b)) : 0;
  }
  function shipDateOf(st) {
    if (st.shipDate) return st.shipDate;
    var sc = st.scans || [], i;
    for (i = sc.length - 1; i >= 0; i--) { if (sc[i].k === 'P') return sc[i].d; }
    for (i = sc.length - 1; i >= 0; i--) { if (sc[i].k !== 'M') return sc[i].d; }
    return '';
  }

  // ── the route: places in order, oldest first, consecutive repeats merged ──
  function places(st) {
    var out = [];
    (st.scans || []).slice().reverse().forEach(function (s) {
      var name = placeOf(s);
      if (!name) return;
      var last = out[out.length - 1];
      if (last && last.name === name) { last.d = s.d; last.t = s.t; last.k = s.k; return; }
      out.push({ name: name, d0: s.d, d: s.d, t: s.t, k: s.k, k0: s.k, fac: !!s.fac });
    });
    return out;
  }
  function destName(st) { var d = st.dest; return d && d.city ? d.city + (d.st ? ', ' + d.st : '') : ''; }
  // Every stop: start → each city passed → here now → destination. trim() then keeps the last few
  // cities for the width the card has (three versions of the strip, picked by a container query).
  function trim(list, maxMid) {
    var mids = list.filter(function (s) { return s.role === 'mid'; });
    var keep = mids.slice(Math.max(0, mids.length - maxMid));
    var out = list.filter(function (s) { return s.role !== 'mid' || keep.indexOf(s) !== -1; });
    out.more = mids.length - keep.length;
    return out;
  }
  function stops(st, state) {
    var pl = places(st), dn = destName(st), out = [];
    var arrived = state === 'dl' || (dn && pl.length && pl[pl.length - 1].name === dn);
    if (!pl.length) {   // no scan list (older lookup, or the carrier sent none): status only
      var upd = st.date ? 'Updated ' + dRel(st.date) : '';
      if (state === 'dl') return [{ role: 'origin', name: 'Shipped', sub: '' }, { role: 'cur', name: dn || 'Delivered', sub: 'Delivered · ' + dRel(st.date) }];
      out.push({ role: 'cur', name: state === 'label' ? 'Waiting for pickup' : (state === 'out' ? 'Out for delivery' : 'On the way'), sub: state === 'label' ? '' : upd });
      out.push({ role: 'dest', name: dn || 'Destination', sub: st.eta && !st.delivered ? dLong(st.eta) : '' });
      return out;
    }
    var first = pl[0], cur = pl[pl.length - 1], mids = pl.slice(1, -1);
    var originSub = (first.k0 === 'M' ? 'Label made ' : 'Picked up ') + dRel(first.d0);
    if (pl.length === 1) {
      out.push({ role: state === 'label' ? 'origin' : 'cur', name: first.name, sub: state === 'label' ? originSub : 'Here now · ' + when(first), fac: first.fac });
    } else {
      out.push({ role: 'origin', name: first.name, sub: originSub, fac: first.fac });
      mids.forEach(function (p) { out.push({ role: 'mid', name: p.name, sub: dRel(p.d) }); });
      out.push({ role: 'cur', name: cur.name, sub: (state === 'dl' || cur.k === 'D' ? 'Delivered · ' : (cur.k === 'O' ? 'Out for delivery · ' : 'Here now · ')) + when(cur) });
    }
    if (!arrived) out.push({ role: 'dest', name: dn || 'Destination', sub: st.eta ? (st.etaType === 'RDD' ? 'New estimate ' : '') + dLong(st.eta) : '' });
    return out;
  }

  // ── markup pieces ────────────────────────────────────────────────────────
  var I = {
    check: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    truck: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3.5V16h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    pin: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-6.5-6.2-6.5-11a6.5 6.5 0 0 1 13 0c0 4.8-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.4"/></svg>',
    flag: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 21V4"/><path d="M5 4h11l-2 4 2 4H5"/></svg>',
    tag: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 12.5V4.5a1 1 0 0 1 1-1h8l8 8-9 9z"/><circle cx="8.5" cy="8.5" r="1.5"/></svg>',
    clock: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>',
    box: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 7.5L12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5L12 12l8.5-4.5"/><path d="M12 12v9"/></svg>',
    copy: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3"/></svg>',
    ext: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4h6v6"/><path d="M20 4l-9 9"/><path d="M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"/></svg>',
    down: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'
  };
  var CONFETTI = [['-22px', '-26px', '#4ade80'], ['26px', '-24px', '#fbbf24'], ['60px', '-18px', '#7fb4ef'], ['110px', '-22px', '#f472b6'], ['160px', '-16px', '#ffffff'], ['210px', '-20px', '#4ade80'], ['-30px', '-6px', '#fbbf24']];
  function confettiHtml() {
    return '<span class="trk2__burst" aria-hidden="true">' + CONFETTI.map(function (c, i) {
      return '<i style="--dx:' + c[0] + ';--dy:' + c[1] + ';background:' + c[2] + ';animation-delay:calc(' + (0.5 + i * 0.02).toFixed(2) + 's + var(--trk-off, 0s))"></i>';
    }).join('') + '</span>';
  }

  function routeHtml(list, cls, play, state) {
    var n = list.length, curI = 0, i;
    for (i = 0; i < n; i++) { if (list[i].role === 'cur') curI = i; }
    var pos = function (k) { return n < 2 ? 50 : 6 + (88 * k) / (n - 1); };
    var fill = pos(curI) - 6;
    // --n sizes each stop's label to the gap between stops (CSS .trk2__route --sw)
    var h = '<div class="trk2__route ' + cls + '" style="--n:' + Math.max(2, n) + '" aria-hidden="true">'
      + '<span class="trk2__line"></span>'
      + (fill > 0 ? '<span class="trk2__fill" style="width:' + fill.toFixed(1) + '%"></span>' : '')
      // cities left out for room: a small "+3 stops" pill on the line after the start
      + (list.more > 0 && n > 1 ? '<span class="trk2__more" style="left:' + ((pos(0) + pos(1)) / 2).toFixed(1) + '%">+' + list.more + ' stop' + (list.more === 1 ? '' : 's') + '</span>' : '');
    list.forEach(function (s, k) {
      var icon;
      if (s.role === 'cur' && state === 'dl') icon = '<span class="trk2__here"><span class="trk2__truck trk2__truck--done">' + I.check + '</span></span>';
      else if (s.role === 'cur') icon = '<span class="trk2__here"><span class="trk2__halo"></span><span class="trk2__truck">' + I.truck + '</span></span>';
      else if (s.role === 'origin') icon = '<span class="trk2__pin">' + I.pin + '</span>';
      else if (s.role === 'dest') icon = '<span class="trk2__flag">' + I.flag + '</span>';
      else icon = '<span class="trk2__dot"></span>';
      h += '<span class="trk2__stop trk2__stop--' + s.role + (k === 0 ? ' trk2__stop--first' : '') + (k === n - 1 && n > 1 ? ' trk2__stop--last' : '') + '" style="left:' + pos(k).toFixed(1) + '%' + (play ? ';animation-delay:calc(' + (0.25 + k * 0.3).toFixed(2) + 's + var(--trk-off, 0s))' : '') + '">'
        + '<span class="trk2__ic">' + icon + '</span>'
        + '<span class="trk2__nm">' + esc(s.name) + '</span>'
        + (s.sub ? '<span class="trk2__sb">' + esc(s.sub) + '</span>' : '')
        + '</span>';
    });
    return h + '</div>';
  }
  // Phones (card under 480px): the same start → here now → destination as a short vertical list.
  function listRouteHtml(list, state) {
    var ic = function (s) {
      if (s.role === 'cur') return '<span class="trk2__vic trk2__vic--cur">' + (state === 'dl' ? I.check : I.truck) + '</span>';
      return '<span class="trk2__vic">' + (s.role === 'origin' ? I.pin : (s.role === 'dest' ? I.flag : '')) + '</span>';
    };
    return '<ol class="trk2__route trk2__route--list" aria-hidden="true">' + trim(list, 0).map(function (s) {
      return '<li class="trk2__vi trk2__vi--' + s.role + '">' + ic(s) + '<span class="trk2__vt"><b>' + esc(s.name) + '</b>' + (s.sub ? '<span>' + esc(s.sub) + '</span>' : '') + '</span></li>';
    }).join('') + '</ol>';
  }
  function srText(list) {
    return list.map(function (s) {
      var lbl = { origin: 'Started at', mid: 'Passed', cur: 'Now at', dest: 'Heading to' }[s.role] || '';
      return lbl + ' ' + s.name + (s.sub ? ' (' + s.sub + ')' : '');
    }).join('; ') + '.';
  }

  window.MPTrack = function (h) {
    var open = {}, sel = {}, last = {}, played = {}, ends = {};
    function ro() { return !!(h && h.ro && h.ro()); }
    function seenMap() { try { return JSON.parse(localStorage.getItem(SEEN_KEY) || '{}') || {}; } catch (e) { return {}; } }
    function markSeen(id, k) {
      if (ro()) return;
      try {
        var m = seenMap(); m[id] = k;
        var keys = Object.keys(m); if (keys.length > 300) keys.slice(0, keys.length - 300).forEach(function (x) { delete m[x]; });
        localStorage.setItem(SEEN_KEY, JSON.stringify(m));
      } catch (e) { /* private window: just plays again next time */ }
    }

    function boxesOf(o) {
      if (o.tracking && o.tracking.length) return o.tracking;
      var raw = String(o.tracking_number || '').split(/[\s,;\/]+/).filter(Boolean);
      return raw.map(function (n) { return { num: n, link: 'https://t.17track.net/en#nums=' + encodeURIComponent(n) }; });
    }

    // The scan list for one box, newest first.
    function tableHtml(t, carrier) {
      var st = t.status, sc = st && st.scans || [];
      if (!sc.length) {
        return '<div class="trk2__none">No updates from ' + esc(carrier || 'the carrier') + ' yet for this box. '
          + (t.link ? '<a href="' + esc(t.link) + '" target="_blank" rel="noopener">Check ' + esc(carrier ? carrier + '.com' : 'the carrier’s site') + '</a>' : '') + '</div>';
      }
      return '<div class="trk2__tblwrap"><table class="trk2__tbl"><caption>Every update from ' + esc(carrier || 'the carrier') + ' <span>· newest first</span></caption>'
        + '<thead><tr><th scope="col">When</th><th scope="col">Where</th><th scope="col">What happened</th></tr></thead><tbody>'
        + sc.map(function (s, i) {
          return '<tr' + (i === 0 ? ' class="is-latest"' : '') + '><td class="trk2__when">' + esc(when(s)) + '</td>'
            + '<td>' + (placeOf(s) ? esc(placeOf(s)) : '<span class="trk2__dim">—</span>') + '</td>'
            + '<td>' + (i === 0 ? '<b>' + esc(s.desc || '') + '</b> <span class="trk2__latest">Latest</span>' : esc(s.desc || '')) + '</td></tr>';
        }).join('') + '</tbody></table></div>';
    }
    function transitHtml(st, state, delivered) {
      var ship = pd(shipDateOf(st));
      if (!ship) return '';
      if (state === 'dl' && delivered) {
        var n = transitDays(st, delivered);
        return n ? '<div class="trk2__tt"><b>Time in transit</b><span>Picked up ' + esc(dLong(shipDateOf(st))) + ' · delivered in ' + n + ' day' + (n === 1 ? '' : 's') + '</span></div>' : '';
      }
      var eta = pd(st.eta);
      if (!eta) return '';
      var day = Math.max(1, days(ship, today0()) + 1), total = Math.max(day, days(ship, eta) + 1);
      return '<div class="trk2__tt"><b>Time in transit</b><span>Picked up ' + esc(dRel(shipDateOf(st))) + ' · <b>Day ' + day + '</b> of about ' + total + '</span>'
        + '<span class="trk2__bar"><i style="width:' + Math.min(100, Math.round((day / total) * 100)) + '%"></i></span></div>';
    }
    function panelHtml(o, boxes, li, carrier, state, delivered) {
      var id = String(o.id), bi = sel[id] != null && boxes[sel[id]] ? sel[id] : li, t = boxes[bi];
      var chips = boxes.length > 1 ? '<div class="trk2__chips" role="group" aria-label="Show updates for">' + boxes.map(function (b, i) {
        return '<button type="button" class="trk2__chip' + (i === bi ? ' is-on' : '') + '" aria-pressed="' + (i === bi ? 'true' : 'false') + '" data-trk-box="' + i + '" data-trk-id="' + esc(id) + '">Box ' + (i + 1) + ' · ' + BOX_TXT[boxState(b)] + '</button>';
      }).join('') + '</div>' : '';
      var list = boxes.length > 1 ? '<div class="trk2__boxes"><b>Boxes</b>' + boxes.map(function (b, i) {
        var k = boxState(b);
        return '<a class="trk2__bx" href="' + esc(b.link || '#') + '" target="_blank" rel="noopener"><span><b>Box ' + (i + 1) + ' of ' + boxes.length + '</b><span>' + esc(b.num) + '</span></span><span class="trk2__pill trk2__pill--' + k + '">' + BOX_TXT[k] + '</span></a>';
      }).join('')
        + '<button type="button" class="trk2__btn trk2__btn--wide" data-trk-copy="' + esc(boxes.map(function (b) { return b.num; }).join('\n')) + '">' + I.copy + '<span>Copy all ' + boxes.length + ' tracking numbers</span></button></div>' : '';
      var side = (t.status ? transitHtml(t.status, state, delivered) : '') + list;
      return '<div class="trk2__panel" id="trk2-p-' + esc(id) + '">' + chips
        + '<div class="trk2__cols"><div class="trk2__main">' + tableHtml(t, carrier) + '</div>' + (side ? '<div class="trk2__side">' + side + '</div>' : '') + '</div>'
        + '<p class="trk2__src">Tracking updates come from ' + esc(carrier || 'the carrier') + ' and refresh about every 45 minutes.</p></div>';
    }
    function footHtml(o, boxes, lead, carrier, isOpen, label) {
      var id = String(o.id), n = lead.status && lead.status.scans ? lead.status.scans.length : 0;
      // "and each box" drops on narrow cards (.trk2__tg-x) so the button stays one line
      var lbl = isOpen ? esc('Hide updates') : (label ? esc(label) : esc('See every update' + (n ? ' (' + n + ')' : '')) + (boxes.length > 1 ? '<span class="trk2__tg-x"> and each box</span>' : ''));
      return '<div class="trk2__foot">'
        + '<button type="button" class="trk2__toggle' + (isOpen ? ' is-open' : '') + '" aria-expanded="' + (isOpen ? 'true' : 'false') + '" aria-controls="trk2-p-' + esc(id) + '" data-trk-toggle="' + esc(id) + '"><span>' + lbl + '</span>' + I.down + '</button>'
        + '<span class="trk2__num"><span>' + esc(lead.num) + '</span>'
        + '<button type="button" class="trk2__btn trk2__btn--ic" data-trk-copy="' + esc(lead.num) + '" aria-label="Copy tracking number" title="Copy tracking number">' + I.copy + '</button>'
        + (lead.link ? '<a class="trk2__btn" href="' + esc(lead.link) + '" target="_blank" rel="noopener">' + esc(carrier ? carrier + '.com' : 'Carrier site') + I.ext + '</a>' : '')
        + '</span></div>';
    }

    function html(o) {
      if (!o) return '';
      var boxes = boxesOf(o);
      if (!boxes.length) return '';
      var id = String(o.id);
      last[id] = o;
      var state = orderState(boxes), li = leadIndex(boxes, state), lead = boxes[li], st = lead.status || {};
      var carrier = carrierOf(lead), service = st.service || carrier;
      var delivered = state === 'dl' ? deliveredOn(boxes) : '';
      var isOld = state === 'dl' && delivered && pd(delivered) && days(pd(delivered), today0()) >= OLD_DAYS;
      var isOpen = !!open[id];
      var nBox = boxes.length > 1 ? boxes.length + ' boxes' : '';

      // No live updates for any box (USPS, freight, or the lookup wasn't available): the numbers + links.
      if (state === 'none') {
        return '<section class="trk2 trk2--plain" data-trk-id="' + esc(id) + '" aria-label="Tracking"><div class="trk2__plain"><b>Tracking</b>'
          + boxes.map(function (b) {
            var c = carrierOf(b);
            return '<span class="trk2__num"><span>' + esc(b.num) + '</span><button type="button" class="trk2__btn trk2__btn--ic" data-trk-copy="' + esc(b.num) + '" aria-label="Copy tracking number" title="Copy tracking number">' + I.copy + '</button>'
              + (b.link ? '<a class="trk2__btn" href="' + esc(b.link) + '" target="_blank" rel="noopener">' + esc(c ? 'Track on ' + c + '.com' : 'Track this shipment') + I.ext + '</a>' : '') + '</span>';
          }).join('') + '</div></section>';
      }

      // A week after delivery: a slim green row — when it arrived, who signed / where it was left, the
      // service, how long it took, the tracking number (copy + carrier site), and Details for every scan.
      if (isOld) {
        var sgO = signerOf(st), tookO = transitDays(st, delivered);
        var factsO = [sgO ? 'Signed by ' + sgO : '', st.place ? 'Left at ' + st.place : '', service, nBox, tookO ? 'took ' + tookO + ' day' + (tookO === 1 ? '' : 's') : ''].filter(Boolean).join(' · ');
        return '<section class="trk2 trk2--old' + (isOpen ? ' is-open' : '') + '" data-trk-id="' + esc(id) + '" aria-labelledby="trk2-h-' + esc(id) + '">'
          + '<div class="trk2__oldrow"><span class="trk2__ok">' + I.check + '</span>'
          + '<span class="trk2__oldt"><span class="trk2__oldk">Delivered</span><b id="trk2-h-' + esc(id) + '">' + esc(dLong(delivered) + (st.time ? ' · ' + hm(st.time) : '')) + '</b>' + (factsO ? '<span>' + esc(factsO) + '</span>' : '') + '</span>'
          + '<span class="trk2__num"><span>' + esc(lead.num) + '</span>' + (boxes.length > 1 ? '<span class="trk2__nmore">+' + (boxes.length - 1) + ' more</span>' : '')
          + '<button type="button" class="trk2__btn trk2__btn--ic" data-trk-copy="' + esc(boxes.map(function (b) { return b.num; }).join('\n')) + '" aria-label="Copy tracking number' + (boxes.length > 1 ? 's' : '') + '" title="Copy tracking number' + (boxes.length > 1 ? 's' : '') + '">' + I.copy + '</button>'
          + (lead.link ? '<a class="trk2__btn" href="' + esc(lead.link) + '" target="_blank" rel="noopener">' + esc(carrier ? carrier + '.com' : 'Carrier site') + I.ext + '</a>' : '') + '</span>'
          + '<button type="button" class="trk2__toggle' + (isOpen ? ' is-open' : '') + '" aria-expanded="' + (isOpen ? 'true' : 'false') + '" aria-controls="trk2-p-' + esc(id) + '" data-trk-toggle="' + esc(id) + '"><span>' + (isOpen ? 'Hide' : 'Details') + '</span>' + I.down + '</button></div>'
          + (isOpen ? panelHtml(o, boxes, li, carrier, state, delivered) : '') + '</section>';
      }

      // Plays once per order per state in this browser. The page redraws the order often (the fresh
      // copy landing after the cached one, a tab click), so a redraw inside the first PLAY_SECS carries
      // the animation on from where it was (--trk-off shifts every delay back) instead of cutting it.
      var celebrate = state === 'tr' || state === 'out' || state === 'dl' || state === 'part';
      if (celebrate && played[id] === undefined) {
        if (seenMap()[id] !== state) { played[id] = Date.now(); markSeen(id, state); } else played[id] = 0;
      }
      var since = played[id] ? (Date.now() - played[id]) / 1000 : 1e9;
      var play = celebrate && since < PLAY_SECS;
      var off = play && since > 0.05 ? ' style="--trk-off:-' + since.toFixed(2) + 's"' : '';
      // When the moment is over the card drops .trk2--play, so a strip that only shows later (a resize or a
      // phone turned sideways switches strips) doesn't fade in all over again.
      if (play && !ends[id]) {
        ends[id] = setTimeout(function () {
          var el = document.querySelector('.trk2[data-trk-id="' + id + '"]');
          if (el) { el.classList.remove('trk2--play'); el.style.removeProperty('--trk-off'); }
        }, Math.max(0, (PLAY_SECS - since) * 1000) + 150);
      }

      var shipD = shipDateOf(st), kick, head, right = '', badge = I.check, tone = '', dlNote = '';
      var etaTxt = st.eta && !st.delivered ? dLong(st.eta) : '';
      var togo = '';
      if (etaTxt) {
        var dn = days(today0(), pd(st.eta));
        togo = dn === 0 ? 'Today' : (dn === 1 ? 'Tomorrow' : (dn > 1 ? dn + ' days to go' : ''));
      }
      if (state === 'dl') {
        tone = ' trk2--dl';
        kick = 'Delivered ' + dLong(delivered) + (st.time ? ', ' + hm(st.time) : '');
        head = 'Delivered!';
        // Right side: who signed, else where it was left, else how long it took; the rest goes on the note line.
        var sg = signerOf(st), took = transitDays(st, delivered), tookTxt = took ? took + ' day' + (took === 1 ? '' : 's') : '';
        if (sg) right = '<span class="trk2__rl">Signed by</span><span class="trk2__rv">' + esc(sg) + '</span>';
        else if (st.place) right = '<span class="trk2__rl">Left at</span><span class="trk2__rv">' + esc(st.place) + '</span>';
        else if (took) right = '<span class="trk2__rl">Delivered in</span><span class="trk2__rv">' + esc(tookTxt) + '</span>';
        dlNote = [sg && st.place ? 'Left at ' + st.place : '', (sg || st.place) && took ? 'Took ' + tookTxt + ' from pickup' : ''].filter(Boolean).join(' · ');
      } else if (state === 'part') {
        var nd = boxes.filter(function (b) { return boxState(b) === 'dl'; }).length;
        kick = nd + ' of ' + boxes.length + ' boxes delivered';
        head = 'Partly delivered';
      } else if (state === 'x') {
        tone = ' trk2--x'; badge = I.clock;
        kick = 'Running late · ' + (service || 'Carrier');
        head = 'A little behind schedule';
      } else if (state === 'out') {
        kick = 'Out for delivery · ' + (service || carrier);
        head = 'Arriving today';
      } else if (state === 'label') {
        tone = ' trk2--label'; badge = I.tag;
        kick = 'Label made' + (shipD ? ' ' + dLong(shipD) : '') + (nBox ? ' · ' + nBox : '');
        head = 'Packed and waiting for pickup';
      } else {
        // "Picked up" (the carrier's own date), not "Shipped": the order header's ship date is the factory's
        // planned date and can differ by a day or two.
        kick = (shipD ? 'Picked up ' + dLong(shipD) : 'On the way') + (service ? ' · ' + service : '') + (nBox ? ' · ' + nBox : '');
        head = 'Your order has shipped!';
      }
      if (!right && etaTxt && state !== 'label') {
        right = '<span class="trk2__rl">' + (st.etaType === 'RDD' ? 'New estimate' : 'Arrives') + '</span><span class="trk2__rv">' + esc(etaTxt) + '</span>'
          + (togo ? '<span class="trk2__togo">' + esc(togo) + '</span>' : '');
      }
      var note = state === 'x' && st.status ? '<p class="trk2__note">' + esc(carrier || 'The carrier') + ' says: ' + esc(st.status) + '</p>'
        : (state === 'label' ? '<p class="trk2__note">' + esc(carrier || 'The carrier') + ' has the shipping label. Tracking starts at the first scan.</p>'
          : (dlNote ? '<p class="trk2__note">' + esc(dlNote) + '</p>' : ''));

      var list = stops(st, state);
      return '<section class="trk2' + tone + (play ? ' trk2--play' : '') + (isOpen ? ' is-open' : '') + '"' + off + ' data-trk-id="' + esc(id) + '" aria-labelledby="trk2-h-' + esc(id) + '">'
        + '<div class="trk2__band"><div class="trk2__top">'
        + '<div class="trk2__hd">' + (play && state !== 'x' ? confettiHtml() : '') + '<span class="trk2__badge">' + badge + '</span>'
        + '<div class="trk2__ht"><span class="trk2__kick">' + esc(kick) + '</span><h4 class="trk2__h" id="trk2-h-' + esc(id) + '">' + esc(head) + '</h4></div></div>'
        + (right ? '<div class="trk2__right">' + right + '</div>' : '') + '</div>'
        + note
        + ROUTES.map(function (r) { return routeHtml(trim(list, r[1]), 'trk2__route--' + r[0], play, state); }).join('') + listRouteHtml(list, state)
        + '<p class="trk2__sr">' + esc(srText(list)) + '</p></div>'
        + footHtml(o, boxes, lead, carrier, isOpen)
        + (isOpen ? panelHtml(o, boxes, li, carrier, state, delivered) : '')
        + '</section>';
    }

    function redraw(id, focusSel) {
      var el = document.querySelector('.trk2[data-trk-id="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]');
      if (!el || !last[id]) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html(last[id]);
      var nu = tmp.firstChild;
      if (!nu) return;
      el.parentNode.replaceChild(nu, el);
      if (focusSel) { var f = nu.querySelector(focusSel); if (f) f.focus(); }
    }
    function copyText(txt, btn) {
      var done = function () {
        btn.classList.add('is-copied');
        var sp = btn.querySelector('span'), was = sp ? sp.textContent : '';
        if (sp) sp.textContent = 'Copied';
        btn.setAttribute('title', 'Copied');
        setTimeout(function () { btn.classList.remove('is-copied'); if (sp) sp.textContent = was; btn.setAttribute('title', 'Copy tracking number'); }, 1600);
      };
      var fallback = function () {
        var ta = document.createElement('textarea');
        ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (e) { /* nothing more to try */ }
        document.body.removeChild(ta);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, fallback);
      else fallback();
    }
    document.addEventListener('click', function (e) {
      var tg = e.target.closest && e.target.closest('[data-trk-toggle]');
      if (tg) { var id = tg.getAttribute('data-trk-toggle'); open[id] = !open[id]; redraw(id, '[data-trk-toggle]'); return; }
      var bx = e.target.closest && e.target.closest('[data-trk-box]');
      if (bx) { var bid = bx.getAttribute('data-trk-id'); sel[bid] = +bx.getAttribute('data-trk-box'); redraw(bid, '[data-trk-box="' + sel[bid] + '"]'); return; }
      var cp = e.target.closest && e.target.closest('[data-trk-copy]');
      if (cp) { e.preventDefault(); copyText(cp.getAttribute('data-trk-copy'), cp); }
    });

    return { html: html, _t: { orderState: orderState, boxState: boxState, stops: stops, trim: trim, places: places, leadIndex: leadIndex } };
  };
})();
